import React from 'react';
import { Link } from 'react-router-dom';

const CerezPolitikasi: React.FC = () => {
  return (
    <div className="page-content">
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Çerez Politikası
          </h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Motopack web sitesinde çerez kullanımı ile ilgili bilgiler aşağıda yer almaktadır.
          </p>
        </div>
      </section>
      <section className="about-content" style={{ background: 'var(--bg-primary)', paddingTop: '2.5rem', paddingBottom: '2.5rem' }}>
        <div className="container">
          <div style={{ background: 'var(--primary-lightest)', borderRadius: '12px', padding: '1.1rem 1.2rem', marginBottom: '1.2rem', color: 'var(--primary-dark)', fontWeight: 600, fontSize: '1.05rem', boxShadow: '0 2px 8px 0 rgba(0,102,204,0.07)', textAlign: 'center' }}>
            Sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanmaktadır. Çerez politikamızda zaman zaman güncellemeler yapılabilir. Bu nedenle, en güncel sürüm için periyodik olarak sitemizi ziyaret etmenizi öneririz.
          </div>
          <h2 style={{ fontWeight: 700, fontSize: '1.3rem', color: 'var(--primary-color)', marginBottom: '1.2rem' }}>Çerez Politikası</h2>
          <div style={{ color: 'var(--text-secondary)', fontSize: '1rem', marginBottom: '1.2rem', lineHeight: 1.7 }}>
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>I. Çerez Nedir?</h3>
            Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla bilgisayarınıza veya mobil cihazınıza kaydedilen küçük metin dosyalarıdır. Bu dosyalar, siteyi tekrar ziyaret ettiğinizde sizi tanımamıza ve tercihlerinizi hatırlamamıza yardımcı olur.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>II. Hangi Tür Çerezler Kullanılır?</h3>
            <b>Oturum Çerezleri:</b> Sadece ziyaretiniz süresince geçerli olan ve tarayıcınızı kapattığınızda silinen geçici çerezlerdir.<br />
            <b>Kalıcı Çerezler:</b> Cihazınızda siz silene kadar veya belirli bir süre boyunca kalan çerezlerdir.<br />
            <b>Birinci Taraf Çerezler:</b> Doğrudan ziyaret ettiğiniz web sitesi tarafından yerleştirilen çerezlerdir.<br />
            <b>Üçüncü Taraf Çerezler:</b> İş birliği yapılan üçüncü taraflar (ör. analiz hizmetleri) tarafından yerleştirilen çerezlerdir.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>III. Çerezler Hangi Amaçlarla Kullanılır?</h3>
            <ul style={{ marginLeft: '1.2rem', marginBottom: '1.2rem' }}>
              <li><b>Web sitesinin çalışmasını sağlamak</b></li>
              <li><b>Kullanıcı deneyimini iyileştirmek ve kişiselleştirmek</b></li>
              <li><b>Site trafiğini ve kullanım istatistiklerini analiz etmek</b></li>
              <li><b>Güvenlik ve dolandırıcılığı önlemek</b></li>
              <li><b>Reklam ve pazarlama faaliyetlerini desteklemek</b></li>
            </ul>
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>IV. Çerezleri Nasıl Kontrol Edebilirsiniz?</h3>
            Çoğu internet tarayıcısı, çerezleri otomatik olarak kabul edecek şekilde ayarlanmıştır. Dilerseniz tarayıcı ayarlarınızı değiştirerek çerezleri reddedebilir veya cihazınıza çerez gönderildiğinde uyarı alabilirsiniz. Ancak çerezleri devre dışı bırakmanız, web sitemizin bazı işlevlerinin düzgün çalışmamasına neden olabilir.<br />
            <b>Çerezleri yönetmek için:</b> Tarayıcınızın “Ayarlar” veya “Gizlilik” bölümünden çerez tercihlerinizi değiştirebilirsiniz.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>V. Üçüncü Taraflara Ait Çerezler</h3>
            Web sitemizde, üçüncü taraf hizmet sağlayıcılar (ör. Google Analytics) tarafından yerleştirilen çerezler kullanılabilir. Bu çerezler, ilgili üçüncü tarafların gizlilik politikalarına tabidir. Üçüncü taraf çerezler hakkında daha fazla bilgi almak için ilgili hizmet sağlayıcının web sitesini ziyaret edebilirsiniz.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VI. Çerez Politikası’nda Değişiklikler</h3>
            Motopack, çerez politikasında zaman zaman değişiklik yapabilir. Güncellenmiş politika, bu sayfada yayınlandığı anda geçerli olur. Değişikliklerden haberdar olmak için sayfamızı düzenli olarak kontrol etmenizi öneririz.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VII. İletişim</h3>
            Çerez politikamız hakkında sorularınız için info@motopack.com.tr adresinden bizimle iletişime geçebilirsiniz.
          </div>
        </div>
      </section>
      {/* Yardım Kartı */}
      <section className="help-section" style={{ background: 'transparent', padding: 0, margin: 0 }}>
        <div className="container" style={{ maxWidth: 1200, margin: '0 auto', padding: '0 1.5rem' }}>
          <div style={{
            background: 'var(--primary-lightest)',
            borderRadius: '12px',
            padding: '1.1rem 1.2rem',
            margin: '2.2rem 0 1.2rem 0',
            color: 'var(--primary-dark)',
            fontWeight: 500,
            fontSize: '1.05rem',
            boxShadow: '0 2px 8px 0 rgba(0,102,204,0.07)',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: '1.2rem',
            position: 'relative',
            minHeight: 110,
            flexWrap: 'wrap',
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1.18rem', marginBottom: 6 }}>Herhangi Bir Yardım İhtiyacınız Var mı?</div>
              <div style={{ fontSize: '1.02rem', color: 'var(--primary-dark)', opacity: 0.92 }}>Merak ettiğiniz her konuda, şikayet ve önerilerinizle ilgili olarak bizimle iletişime geçebilirsiniz.</div>
            </div>
            <div style={{ marginLeft: 'auto', alignSelf: 'flex-end' }}>
              <Link to="/iletisim" style={{
                display: 'inline-block',
                background: 'linear-gradient(90deg, var(--primary-color) 0%, var(--primary-light) 100%)',
                color: '#fff',
                fontWeight: 700,
                fontSize: '1rem',
                borderRadius: 8,
                padding: '0.72rem 1.7rem',
                textDecoration: 'none',
                boxShadow: '0 2px 8px 0 rgba(0,102,204,0.09)',
                transition: 'background 0.18s, box-shadow 0.18s',
                position: 'relative',
                bottom: 0,
                right: 0,
                marginTop: 12,
              }}>Bize Yazın</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CerezPolitikasi; 